// @ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../../constant/Endpoint";
import Button from "../../Reusable/Button";
import ComboboxInput from "../../Reusable/ComboboxInput";
import MultiPhoneInput from "../../Reusable/MultiPhoneInput/MultiPhoneInput";
import TextAreaInput from "../../Reusable/TextAreaInput/TextAreaInput";
import TextField from "../../Reusable/TextInput";
import { UploadCloudIcon } from "lucide-react";

const SmsCampaignForm = (props: any) => {
  const {
    register,
    errors,
    control,
    setValue,
    watch,
    getValues,
    clearErrors,
    handleFileButton,
    handlePlusButton,
  } = props;

  return (
    <div>
      <div className={tw`grid grid-cols-1`}>
        <div className={tw`w-full`}>
          <TextField
            placeholder="Enter Campaign Name"
            label="Campaign Name"
            register={register("name")}
            errors={errors.name}
          />
        </div>
      </div>

      <div className={tw`flex gap-4 mt-2`}>
        <div className={tw`w-[90%]`}>
          <MultiPhoneInput
            control={control}
            name="recipient"
            value={watch("recipient") || []}
            label="To"
            errors={errors.recipient}
          />
        </div>
        <div className={tw`w-[10%] relative top-4`}>
          <div className={tw`flex justify-center items-center`}>
            <Button
              label={
                <div className="flex justify-center items-center w-full h-full">
                  <UploadCloudIcon className="text-white w-5 h-5" />
                </div>
              }
              type="button"
              onClick={handleFileButton}
            />
          </div>
        </div>
      </div>
      <div className={tw`flex gap-4`}>
        <div className={tw`w-full`}>
          <ComboboxInput
            url={APIS.SENDER_SMS}
            queryKey="contacts"
            register={register("sender_name")}
            errors={errors?.sender_name}
            name="sender_name"
            props={{ is_active: true }}
            label={"From"}
            setValue={setValue}
            watch={watch}
            placeholder="Enter Sender Name..."
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className={tw`w-[8%] relative top-8`}>
          <div className={tw`text-[20px] leading-none text-center`}>
            <Button
              label="+"
              disabled={true}
              type="button"
              onClick={handlePlusButton}
            />
          </div>
        </div>
      </div>

      <TextAreaInput
        label={
          <div>
            Message
            <span> - Your SMS Content</span>
          </div>
        }
        placeholder="Write a message here..."
        row={8}
        register={register("content", {
          required: "Message field is required.",
        })}
        errors={errors.content}
      />
    </div>
  );
};

export default SmsCampaignForm;
